module.exports = __webpack_public_path__ + "img/banner1.7b60cd59.jpg";